// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-project-project-mobile-stagger----project-mobile-module---wrapper---2vpnR","deviceWrapper":"src-components-project-project-mobile-stagger----project-mobile-module---deviceWrapper---17cId","outerWrapper":"src-components-project-project-mobile-stagger----project-mobile-module---outerWrapper---1Cur3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-mobile-stagger/project-mobile.module.css
// module id = 527
// module chunks = 140935043865547